<template>
  <div v-if="!dialogFormVisible">
    <div v-if="!digshow" class="t_out_box">
      <div
        style="
          background-color: white;
          padding: 30px 0 20px 0;
          margin-bottom: 11px;
          box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
          border-radius: 5px;
        "
      >
        <el-form
          v-model="serachForm"
          class="t_search_form"
          style="width: 90%; margin-left: auto; margin-right: auto"
          label-position="center"
          label-width="90px"
        >
          <el-form-item label="购买入库单号:" label-width="100px" style="">
            <el-input v-model="serachForm.dh" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="退货仓库:">
            <el-select v-model="serachForm.thck" filterable placeholder="请选择">
              <el-option
                v-for="(item, index) in ckKeyList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="退货日期:">
            <el-col :span="10">
              <el-date-picker
                v-model="serachForm.ksDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择日期"
                :picker-options="startTime"
              />
            </el-col>
            <el-col style="text-align: center" class="line" :span="3">-</el-col>
            <el-col :span="10">
              <el-date-picker
                v-model="serachForm.JsDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择日期"
                :picker-options="endTime"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="状态:" label-width="50px">
            <el-select v-model="serachForm.zt" placeholder="请选择">
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-button
            v-preventReClick
            class="sousuoButton"
            icon="el-icon-search"
            round
            size="small"
            type="primary"
            @click="outhandleCurrentChange(1)"
          >搜索</el-button>
          <el-button
            v-preventReClick
            class="chongzhiButton"
            size="small"
            icon="el-icon-refresh-right"
            round
            @click="reset"
          >重置</el-button>
        </el-form>
      </div>
      <div class="t_con_w" style="padding-top: 40px; padding-bottom: 57px">
        <div style="width: 90%; margin-left: auto; margin-right: auto">
          <div
            style="
              background-color: #f4f4f4;
              padding: 12px 10px;
              border: 1px solid #f4f4f4;
            "
          >
            <el-button
              v-preventReClick
              icon="el-icon-plus"
              type="primary"
              size="mini"
              style="background-color: #4170ff; border: none; color: white"
              @click="add(0)"
            >新增</el-button>
            <el-button
              v-preventReClick
              icon="el-icon-plus"
              size="mini"
              style="margin-left: 10px; marign-right: 10px"
              @click="copyAdd"
            >复制新增</el-button>
            <el-button
              v-preventReClick
              icon="el-icon-upload2"
              size="mini"
              @click="dcexcel"
            >导出</el-button>
          </div>
          <el-table
            ref="thckTable"
            :data="tableData"
            :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
            border
            :show-overflow-tooltip="true"
            style="
              width: 100%;
              border-left: 1px solid #f4f4f4;
              border-right: 1px solid #f4f4f4;
            "
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" align="center" width="55" />
            <el-table-column
              align="center"
              prop="ckbh"
              :show-overflow-tooltip="true"
              label="退货出库编号"
            />
            <el-table-column
              align="center"
              prop="gmrkBh"
              :show-overflow-tooltip="true"
              label="购买入库编号"
            />
            <el-table-column
              align="center"
              prop="hxpMc"
              :show-overflow-tooltip="true"
              label="化学品名称"
            />
            <el-table-column
              align="center"
              prop="gmzBh"
              :show-overflow-tooltip="true"
              label="购买证编号"
            />
            <el-table-column
              align="center"
              prop="ckmc"
              :show-overflow-tooltip="true"
              label="退货仓库"
            />
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              label="退货数量"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.cksl + scope.row.ckslDwLabel }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="thrq"
              :show-overflow-tooltip="true"
              label="退货日期"
            />
            <el-table-column align="center" prop="bgcs" label="变更次数">
              <template slot-scope="scope">
                <span
                  v-preventReClick
                  style="cursor: pointer"
                  @click="bgcsClick(scope.row)"
                >{{ scope.row.bgcs }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              label="状态"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.zt == '01'" style="color: #6fc89a">{{
                  scope.row.ztLabel
                }}</span>
                <span v-if="scope.row.zt == '11'" style="color: #43a5e2">{{
                  scope.row.ztLabel
                }}</span>
                <span v-if="scope.row.zt == '00'" style="color: #333333">{{
                  scope.row.ztLabel
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="cz"
              width="200px"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.zt == '01' || scope.row.zt == '11'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-document"
                  style="background-color: #4170ff; border: none; color: white"
                  @click="add(2, scope.row)"
                >查看</el-button>
                <el-button
                  v-if="scope.row.zt == '01'"
                  v-preventReClick
                  :disabled="scope.row.zt == '01' ? false : true"
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #feb800; border: none; color: white"
                  @click="add(3, scope.row)"
                >变更</el-button>
                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #4170ff; border: none; color: white"
                  @click="add(4, scope.row)"
                >编辑</el-button>
                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-delete"
                  style="background-color: #ff5721; border: none; color: white"
                  @click="deleteItem(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :current-page="outCurrentPage"
            :page-size="outPageSize"
            :page-sizes="[10, 20]"
            :total="outTotal"
            class="el-page"
            @size-change="outpagesizeChange"
            @current-change="outhandleCurrentChange"
          />
        </div>
      </div>
    </div>
    <div v-if="digshow" class="t_dig" v-loading = "loading">
      <div
        style="background-color: white; margin-top: 15px; position: relative"
      >
        <div
          v-preventReClick
          style="
            position: absolute;
            right: 30px;
            top: 30px;
            font-size: 30px;
            color: #606266;
            cursor: pointer;
          "
          @click="back"
        >
          <i class="el-icon-circle-close" />
        </div>
        <div class="t_rk">
          <img
            src="@/assets/img/thckxx.png"
            style="height: 25px; margin-bottom: 37px"
          >
          <el-form
            ref="thForm"
            :rules="rule"
            :model="thckForm"
            :disabled="childrenType == 'ck'"
            label-position="right"
            style="
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
            "
            label-width="130px"
          >
            <el-form-item
              label="购买入库单号："
              style="margin-right: 0; width: 45%"
              prop="gmrkBh"
            >
              <el-select
                filterable
                clearable
                v-model="thckForm.gmrkBh"
                placeholder="请选择"
                :disabled="ckdisable || bgdisable"
                style="width: 100%"
                @change="gmrkBhChange"
                @clear="clearBhxx"
              >
                <el-option
                  v-for="(item, index) in rkdhList"
                  :key="index"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="化学品："
              :required="true"
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="thckForm.hxpMc"
                style="width: 100%"
                disabled
              />
            </el-form-item>
            <el-form-item
              label="购买证编号："
              :required="true"
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="thckForm.gmzBh"
                style="width: 100%"
                disabled
              />
            </el-form-item>
            <el-form-item
              label="运输证："
              style="margin-right: 0; width: 45%"
              prop="yszBh"
              :rules="{
                validator: (rule, value, callback) => {
                  lengthValidate(rule, thckForm.yszBh, callback, 'xt', 30);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <div style="position: relative; width: 100%">
                <el-select
                  v-model="thckForm.yszBh"
                  style="width: calc(100% - 80px)"
                  :disabled="ckdisable || bgdisable"
                  placeholder="请选择"
                  @change="yszChange"
                >
                  <el-option label="同市运输" value="同市运输" />
                </el-select>
                <el-input
                  v-model="thckForm.yszBh"
                  style="position: absolute; width: calc(100% - 115px); left: 0"
                  :disabled="ckdisable || bgdisable"
                  placeholder="请输入运输证"
                  @change="yszInputChange"
                />

                <el-button
                  v-preventReClick
                  class="xuanze"
                  :disabled="ckdisable || bgdisable"
                  @click="choose"
                >选择</el-button>
              </div>
            </el-form-item>
            <el-form-item
              label="保管员姓名："
              :required="true"
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="thckForm.bgyxm"
                style="width: 100%"
                disabled
              />
            </el-form-item>
            <el-form-item
              label="保管员电话："
              :required="true"
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="thckForm.bgydh"
                style="width: 100%"
                disabled
              />
            </el-form-item>
            <el-form-item
              label="入库数量："
              :required="true"
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="thckForm.rksl"
                style="width: 60%"
                disabled
              />
              <el-select
                v-model="thckForm.rkslDw"
                placeholder="单位"
                disabled
                style="width: 35%; margin-left: 5%"
              >
                <el-option
                  v-for="(item, index) in dwList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="!ckdisable"
              label="库存量："
              :required="true"
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="thckForm.kcl"
                style="width: 60%"
                disabled
              />
              <el-select
                v-model="thckForm.kclDw"
                placeholder="单位"
                disabled
                style="width: 35%; margin-left: 5%"
              >
                <el-option
                  v-for="(item, index) in dwList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="入库日期："
              :required="true"
              style="margin-right: 0; width: 45%"
            >
              <el-date-picker
                v-model="thckForm.rkrq"
                type="date"
                disabled
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择日期"
              />
            </el-form-item>
            <el-form-item
              label="退货仓库："
              :required="true"
              style="margin-right: 0; width: 45%"
            >
              <el-input v-model="thckForm.ckmc" disabled />
            </el-form-item>
            <el-form-item
              label="退货数量："
              style="margin-right: 0; width: 45%"
              prop="cksl"
            >
              <el-input
                v-model="thckForm.cksl"
                :disabled="ckdisable"
                style="width: 60%"
              />
              <el-select
                v-model="thckForm.ckslDw"
                placeholder="单位"
                :disabled="ckdisable"
                style="width: 35%; margin-left: 5%"
              >
                <el-option
                  v-for="(item, index) in thslDwList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="退货日期："
              style="margin-right: 0; width: 45%"
              prop="thrq"
            >
              <el-date-picker
                v-model="thckForm.thrq"
                :disabled="ckdisable"
                type="date"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                style="width: 100%"
                placeholder="选择日期"
              />
            </el-form-item>
            <el-form-item
              label="经办人："
              prop="jbrName"
              style="margin-right: 0; width: 45%"
            >
              <el-select
                v-model="thckForm.jbrName"
                filterable
                :disabled="ckdisable || bgdisable"
                placeholder="请选择"
                style="width: 100%"
                @change="jbrChange"
              >
                <el-option
                  v-for="(item, index) in jbrList"
                  :key="index"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="登记人："
              :required="true"
              style="margin-right: 0; width: 45%"
            >
              <el-input v-model="thckForm.djrLabel" disabled style="width: 100%" />
            </el-form-item>
            <el-form-item
              v-if="djsjshow"
              label="登记日期："
              style="margin-right: 0; width: 45%"
            >
              <el-date-picker
                v-model="thckForm.djsj"
                type="date"
                disabled
                style="width: 100%"
                placeholder="选择日期"
              />
            </el-form-item>
            <el-form-item v-else label="登记日期:" style="margin-right: 0; width: 45%">
              <el-date-picker
                :value="new Date()"
                type="date"
                style="width: 100%;"
                placeholder="选择日期"
                disabled
                format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item
              v-if="childrenType == 'bg'"
              label="变更理由："
              resize="none"
              prop="bgly"
              style="margin-right: 0; width: 100%"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 1000);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="thckForm.bgly"
                type="textarea"
                resize="none"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item
              label="备注："
              style="margin-right: 0; width: 100%"
              prop="bz"
              :rules="{
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'xt', 255);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="thckForm.bz"
                type="textarea"
                resize="none"
                :disabled="ckdisable || bgdisable"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>

          <div
            v-if="
              childrenType == 'copy' ||
                childrenType == 'add' ||
                childrenType == 'bj'
            "
            style="
              width: 498px;
              margin-left: auto;
              margin-right: auto;
              margin-top: 40px;
              margin-bottom: 45px;
              display: flex;
              justify-content: center;
            "
          >
            <el-button
              v-preventReClick
              type="primary"
              style="
                margin-right: 190px;
                background-color: #ebebeb;
                width: 148px;
                height: 60px;
                color: #333333;
                border: none;
              "
              @click="outBoundTemp"
            >暂时保存</el-button>
            <el-button
              v-preventReClick
              style="
                background-color: #4170ff;
                color: white;
                width: 148px;
                height: 60px;
                border: none;
              "
              type="primary"
              @click="outBound(true)"
            >出库</el-button>
          </div>
          <div
            v-if="childrenType == 'ck' && !curRowObj.bgcs >= 1"
            v-preventReClick
            class="backButton"
            @click="back"
          >
            <el-button type="primary">确定</el-button>
          </div>
          <div
            v-if="childrenType == 'bg' && !curRowObj.bgcs >= 1"
            class="backButton"
          >
            <el-button
              v-preventReClick
              type="primary"
              @click="submitBg"
            >提交变更</el-button>
          </div>
        </div>
      </div>

      <div
        v-if="
          curRowObj.bgcs >= 1 && (childrenType == 'ck' || childrenType == 'bg')
        "
        class="bgcs_bg"
      >
        <div class="title" style="margin-bottom: 30px">
          <img src="@/assets/img/bgsp/ckbg.png" alt="" srcset="">
        </div>
        <bgcsOfDetail
          :cur-row-obj="curRowObj"
          :cur-type="curType"
          :bgcs-t-k-name="'disShow'"
          @bacsCkXqShow="bacsCkXqShow"
        />

        <div
          v-if="childrenType == 'ck'"
          v-preventReClick
          class="backButton"
          @click="back"
        >
          <el-button type="primary">确定</el-button>
        </div>

        <div v-if="childrenType == 'bg'" class="backButton">
          <el-button
            v-preventReClick
            type="primary"
            @click="submitBg"
          >提交变更</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="选择"
      width="1000px"
      :visible.sync="chooseshow"
    >
      <el-table
        ref="yszTable"
        :data="yszListTableData"
        :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
        border
        style="
          width: 100%;
          border-left: 1px solid #f4f4f4;
          border-right: 1px solid #f4f4f4;
        "
        @selection-change="yszHandleSelectionChange"
      >
        <el-table-column type="selection" align="center" width="55" />
        <el-table-column align="center" prop="xkzBh" label="许可证编号" />
        <el-table-column align="center" prop="hxpMc" label="化学品名称" />
        <el-table-column align="center" label="运输数量">
          <template slot-scope="scope">
            <span>{{ scope.row.hzsl + "(" + scope.row.hzslDwMc + ")" }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="fhdwMc" label="发货单位" />
        <el-table-column align="center" prop="sqsj" label="申请时间" />
      </el-table>
      <el-pagination
        background
        layout="prev, pager,next,jumper,total,sizes"
        :current-page="yszListCurrentPage"
        :page-size="yszListPageSize"
        :page-sizes="[10, 20]"
        :total="yszListTotal"
        class="el-page"
        @size-change="pagesizeChange"
        @current-change="handleCurrentChange"
      />
      <div style="text-align: center; margin-top: 30px">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border-color: #4170ff"
          @click="addchoose"
        >确定</el-button>
      </div>
    </el-dialog>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
  </div>
  <div v-else class="bgcs_SJTK">
    <!-- 详情弹框 -->
    <bgxqCom
      v-if="dialogFormVisible"
      bgcs-t-k-name="退货出库"
      :dgcs-xq-id="dgcsXqId"
    />
    <div slot="footer" class="dialog-footer">
      <el-button
        v-preventReClick
        type="primary"
        style="background-color: #4170ff; border: none"
        @click="dialogFormVisible = false"
      >确 定</el-button>
    </div>
  </div>
</template>

<script>
import { lengthValidate } from '@/assets/js/validate'
import bgxqCom from '@/components/bgxq/bgxqCom.vue'
import bgcsOfDetail from '@/components/bgxq/bgInDetail.vue'

// 获取接口地址
import {
  getGmrkXgxx,
  selectYszList,
  addOrUpdSave,
  ckStatusList,
  getJbrList,
  postThckList,
  getThckDetail,
  delThckDetail,
  exportThck,
  changePdkcByThck,
  saveChangeApply, addOrUpdSaveTemp
} from '@/assets/js/thck.js'
import { userInfofLogin, getListCkcx } from '@/assets/js/common.js'
import { getDwByHxp } from '@/assets/js/kccsh.js'
import bgcs from '@/components/bgcs'
export default {
  name: 'Thck',
  components: { bgcs, bgcsOfDetail, bgxqCom },
  data() {
    const sljiaoyan = (rule, value, callback) => {
      // 必填  不能为负数
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
      if (!this.bgdisable && !reg.test(value)) {
        callback(new Error('请输入大于或等于0的数量值'))
      } else if (
        /^-?[1-9]\d{0,8}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(value) == false
      ) {
        return callback(new Error('整数位最大长度9位,保留3位小数'))
      }
      // 单位必选
      if (!this.thckForm.ckslDw) {
        return callback(new Error('请选择退货数量单位'))
      }
      // 入库数量 转换
      var rkslValidator = this.getCurrentDw(
        this.thckForm.rkslDw,
        this.thckForm.rksl
      )
      var kclValidator = this.getCurrentDw(
        this.thckForm.kclDw,
        this.thckForm.kcl
      )
      var thslValidator = this.getCurrentDw(
        this.thckForm.ckslDw,
        this.thckForm.cksl
      )
      if (this.childrenType !== 'bg') {
        if (thslValidator > rkslValidator) {
          callback(new Error('退货数量不得大于入库数量'))
        }
        if (thslValidator > kclValidator) {
          callback(new Error('退货数量不得大于库存量'))
        }
      }

      callback()
    }
    return {
      loading: false,
      bgcsTKName: '退货出库',
      pickerOptions: {
        disabledDate: (time) => {
          return time > Date.now()
        }
      },

      startTime: {
        disabledDate: (time) => {
          if (this.serachForm.JsDate) {
            return time.getTime() > new Date(this.serachForm.JsDate).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.serachForm.ksDate) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.serachForm.ksDate).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      bgwindow: false, // 变更次数弹窗
      serachForm: {}, // 搜索表单
      rkdhList: [], // 获取购买入库单号下拉
      checkedTableList: '', // 列表选择某条
      // 查看禁止
      ckdisable: false,
      // 变更禁止
      bgdisable: false,
      // 登记时间显示
      djsjshow: false,
      digshow: false,
      chooseshow: false,
      tableData: [],
      dwList: [
        { label: '吨', value: '1' },
        { label: '千克', value: '2' },
        { label: '克', value: '3' },
        { label: '升', value: '4' },
        { label: '毫升', value: '5' }
      ],
      // 表单数据
      thckForm: { gmrkBh: '' ,ckslDw:'',yszId:'',yszBh:''},
      /* 搜索相关 */
      statusList: [], // 状态下拉
      ckKeyList: [], // 搜索仓库
      thslDwList: [], // 根据化学品获取退货数量单位
      jbrList: [], // 经办人下拉
      outCurrentPage: 1,
      outPageSize: 10,
      outTotal: 0,
      djr: '', // 登记人
      childrenType: '', // 操作类型
      /* 运输证弹窗 */
      yszListTableData: [], // 表数据
      yszListTotal: 0, // 总数
      yszListCurrentPage: 1, // 运输证列表当前页
      yszListPageSize: 10,
      yszCheckedTableList: '', // 运输证选中
      /* 校验 */
      rule: {
        gmrkBh: [
          { required: true, message: '请选择购买入库单号', trigger: 'change' }
        ],
        cksl: [{ required: true, validator: sljiaoyan, trigger: 'change' }],
        thrq: [
          { required: true, message: '请选择退货日期', trigger: 'change' }
        ],
        jbrName: [
          { required: true, message: '请选择经办人', trigger: 'change' }
        ]
        // bgly: [
        //   { required: true, message: "请填写变更理由", trigger: "change" },
        // ],
      },

      curType: '',
      curRowObj: {}, // 当前行的对象
      dialogFormVisible: false,
      dgcsXqId: null
    }
  },
  watch: {
    /* "thckForm.gmrkBh"(newValue, oldValue) {
      if (newValue != undefined && newValue != null) {
      }
    }, */
    'thckForm.hxpBm'(newValue, oldValue) {
      if (newValue != undefined && newValue != null) {
        getDwByHxp(newValue).then((e) => {
          this.thslDwList = e.data.data
        })
      }
    }
  },
  created: function() {
    this.loadDataSource()
  },
  methods: {
    lengthValidate,
    // 变更次数弹框
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
      this.dialogFormVisibl = false
    },

    // 点击变更次数
    bgcsClick(curRow) {
      this.curRowObj = curRow
      this.$bus.emit('bgcsOpen', curRow, '10')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 根据单位转换数量 做校验用
    getCurrentDw(dw, sl) {
      switch (dw) {
        case '1': // 吨
          return sl * 1000000
        case '2': // 千克
          return sl * 1000
        case '3': // 克
          return sl
        case '4': // 升
          return sl * 1000
        case '5': // 毫升
          return sl
      }
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // 运输证单选
    yszHandleSelectionChange(val) {
      this.yszCheckedTableList = val
      if (val.length > 1) {
        this.$refs.yszTable.clearSelection()
        this.$refs.yszTable.toggleRowSelection(val.pop())
      }
    },
    // 外部分页方法
    reset() {
      this.serachForm.dh = ''
      this.serachForm.thck = ''
      this.serachForm.ksDate = ''
      this.serachForm.JsDate = ''
      this.serachForm.zt = ''
      this.outCurrentPage = 1
      this.thckList()
    },
    thckList() {
      postThckList({
        page: this.outCurrentPage,
        size: this.outPageSize,
        param: {
          gmrkBhLike: this.serachForm.dh,
          ckId: this.serachForm.thck,
          beginThrq: this.serachForm.ksDate,
          endThrq: this.serachForm.JsDate,
          zt: this.serachForm.zt
        }
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.outTotal = e.data.data.total
      })
    },
    // 选择经办人拉取隐藏属性
    jbrChange(val) {
      this.jbrList.filter((item, index) => {
        if (item.label == val) {
          this.thckForm.jbrId = item.value
        }
      })
    },
    // 删除记录
    deleteItem(row) {
      this.$confirm('是否删除本条退货出库信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delThckDetail(row.id).then((e) => {
            if (e.data.code == '000000') {
              this.thckList()
              this.$message({
                message: '删除成功!',
                type: 'success'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 暂存
    outBoundTemp() {
      this.thckForm.zt = '00'
      this.$confirm('是否暂时保存本次退货出库操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            this.loading = true
            // copy需要去除id
            this.childrenType == 'copy'
                ? this.$delete(this.thckForm, 'id')
                : ''
            addOrUpdSaveTemp(this.thckForm).then((e) => {
              this.loading = false
              if (e.data.code == '000000') {
                this.digshow = !this.digshow
                this.thckList()
                this.thckForm = {}
                this.$message({
                  message: '暂时保存成功!',
                  type: 'success'
                })
              }
            }).catch((error) => {
              this.loading = false
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
    },
    // 出库提交
    outBound(type) {
      this.$refs['thForm'].validate((valid) => {
        if (valid) {
          var arr = type ? '提交' : '暂时保存'
          this.$confirm('是否' + arr + '本次退货出库操作', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.loading = true
              // 状态状态：00草稿，01已出库"
              this.thckForm.zt = type ? '01' : '00'
              // copy需要去除id
              this.childrenType == 'copy'
                ? this.$delete(this.thckForm, 'id')
                : ''
              addOrUpdSave(this.thckForm).then((e) => {
                this.loading = false
                if (e.data.code == '000000') {
                  this.digshow = !this.digshow
                  this.thckList()
                  this.thckForm = {}
                  this.$message({
                    message: '提交成功!',
                    type: 'success'
                  })
                }
              }).catch((error) => {
                this.loading = false
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
        }
      })
    },
    // 运输证分页方法
    yszListSearch() {
      if (this.thckForm.gmzId) {
        selectYszList({
          page: this.yszListCurrentPage,
          size: this.yszListPageSize,
          param: { gmzId: this.thckForm.gmzId }
        }).then((e) => {
          this.yszListTableData = e.data.data.rows
          this.yszListTotal = e.data.data.total
        })
        return true
      } else {
        this.$message({
          message: '请先选择购买入库单号',
          type: 'warning'
        })
        return false
      }
    },
    // 导出
    dcexcel() {
      this.$confirm('是否导出退货出库信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          exportThck({
            param: {
              gmrkBh: this.serachForm.dh,
              ckId: this.serachForm.thck,
              beginThrq: this.serachForm.ksDate,
              endThrq: this.serachForm.JsDate,
              zt: this.serachForm.zt
            }
          }).then((e) => {
            const table = '退货出库'
            const a = document.createElement('a')
            const blob = new Blob([e.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 选择按钮
    choose() {
      if (this.yszListSearch()) {
        this.chooseshow = true
      }
    },
    // 选择购买入库后拉取数据
    gmrkBhChange(val) {
      this.rkdhList.filter((item, index) => {
        this.thckForm.yszId = ''
        this.thckForm.yszBh = ''
        this.thckForm.ckslDw = ''
        if (item.label == val) {
          this.thckForm.gmrkId = item.value
          this.thckForm.hxpMc = item.hxpMc
          this.thckForm.hxpBm = item.hxpBm
          this.thckForm.gmzBh = item.gmzBh
          this.thckForm.gmzId = item.gmzId
          this.thckForm.bgyxm = item.bgyxm
          this.thckForm.bgyId = item.bgyId
          this.thckForm.bgydh = item.bgydh
          this.thckForm.rksl = item.rksl
          this.thckForm.rkslDw = item.rkslDw
          this.thckForm.kcl = item.kcl
          this.thckForm.kclDw = item.kclDw
          this.thckForm.rkrq = item.rkrq
          this.thckForm.ckmc = item.ckmc
          this.thckForm.ckId = item.ckId
          // 根据化学品获取单位下拉
          getDwByHxp(this.thckForm.hxpBm).then((e) => {
            this.thslDwList = e.data.data
          })
        }
      })
    },
    //清除购买入库
    clearBhxx(){
      this.thckForm.gmrkId = ''
      this.thckForm.gmrkBh = ''
    },
    // 复制新增
    copyAdd() {
      if (this.checkedTableList == '') {
        this.$message.warning('请先选中一条数据!')
      } else {
        // 复制新增
        this.digshow = !this.digshow
        this.ckdisable = false
        this.djsjshow = false
        this.bgdisable = false
        this.childrenType = 'copy'
        getGmrkXgxx().then((e) => {
          this.rkdhList = e.data.data
        })
        // 根据id获取详情
        getThckDetail(this.checkedTableList[0].id).then((e) => {
          let dataMes = e.data.data
          let mesxx = {...dataMes}
          if(!this.bgdisable && this.leixing != 'ck'){
            mesxx.jbrId = this.thckForm.jbrId
            mesxx.jbrName = this.thckForm.jbrName
          }
          this.thckForm = mesxx
          getJbrList().then((e) => {
            this.jbrList = e.data.data
            this.jbrList.findIndex((item) => {
              if(item.value == dataMes.jbrId){
                this.thckForm.jbrId = dataMes.jbrId
                this.thckForm.jbrName = dataMes.jbrName
                return
              }
            })
          })
          this.$nextTick(() => {
            this.$refs.thForm.clearValidate() //清楚页面所有校验结果
          })
        })
        this.checkedTableList = ''
      }
    },
    // 多选框设置为单选功能
    handleSelectionChange(val) {
      this.checkedTableList = val
      if (val.length > 1) {
        this.$refs.thckTable.clearSelection()
        this.$refs.thckTable.toggleRowSelection(val.pop())
      }
    },
    // 操作集
    add(type, row) {
      this.curRowObj = {}
      this.curType = 10
      this.dialogFormVisibl = false
      // 弹窗开关
      this.digshow = !this.digshow
      // 获取入库单号下拉
      getGmrkXgxx().then((e) => {
        this.rkdhList = e.data.data
      })
      if (type == 0) {
        // 新增
        this.ckdisable = false
        this.djsjshow = false
        this.bgdisable = false
        this.childrenType = 'add'
        getJbrList().then((e) => {
          this.jbrList = e.data.data
        })
      } else if (type == 2) {
        // 查看
        this.ckdisable = true
        this.djsjshow = true
        this.bgdisable = false
        this.childrenType = 'ck'
        getThckDetail(row.id).then((e) => {
          this.thckForm = e.data.data
        })

        this.initCon(row, 10)
      } else if (type == 3) {
        // 变更
        this.ckdisable = false
        this.djsjshow = true
        this.bgdisable = true
        this.childrenType = 'bg'
        getThckDetail(row.id).then((e) => {
          this.thckForm = e.data.data
        })

        this.initCon(row, 10)
      } else if (type == 4) {
        // 编辑
        this.ckdisable = false
        this.djsjshow = true
        this.bgdisable = false
        this.childrenType = 'bj'
        getThckDetail(row.id).then((e) => {
          let dataMes = e.data.data
          let mesxx = {...e.data.data}
          if(!this.bgdisable && this.leixing != 'ck'){
            mesxx.jbrId = this.thckForm.jbrId
            mesxx.jbrName = this.thckForm.jbrName
          }
          this.thckForm = mesxx
          getJbrList().then((e) => {
            this.jbrList = e.data.data
            this.jbrList.findIndex((item) => {
              if(item.value ==dataMes.jbrId){
                this.thckForm.jbrId =dataMes.jbrId
                this.thckForm.jbrName =dataMes.jbrName
                return
              }
            })
          })
          this.$nextTick(() => {
            this.$refs.thForm.clearValidate() //清楚页面所有校验结果
          })
        })
      }
    },
    // 提交变更
    submitBg() {
      this.$refs['thForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          changePdkcByThck({
            id: this.thckForm.id,
            hxpBm: this.thckForm.hxpBm,
            ckId: this.thckForm.ckId,
            cksl: this.thckForm.cksl,
            ckslDw: this.thckForm.ckslDw,
            gmrkId: this.thckForm.gmrkId
          }).then((e) => {
            this.loading = false
            this.$confirm(
                e.data.data.type == 'success'?'是否确认提交变更?':
              "<span style='color:red'>" +
                e.data.data.msg +
                '</span>是否确认提交变更?',
              '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning'
              }
            )
              .then(() => {
                this.loading = true
                saveChangeApply(this.thckForm).then((e) => {
                  this.loading = false
                  if (e.data.code == '000000') {
                    this.digshow = !this.digshow
                    this.thckList()
                    this.thckForm = {}
                    this.$message({
                      message: '变更成功!',
                      type: 'success'
                    })
                  }
                }).catch((error) => {
                  this.loading = false
                })
              })
              .catch(() => {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
          })
        }
      })
    },
    yszInputChange(val) {
      this.thckForm.yszId = ''
    },
    yszChange(val) {
      this.thckForm.yszId = ''
    },
    // 确认选择按钮
    addchoose() {
      this.thckForm.yszBh = this.yszCheckedTableList[0].xkzBh
      this.thckForm.yszId = this.yszCheckedTableList[0].id
      this.chooseshow = false
    },
    // 外部分页方法
    outpagesizeChange(val) {
      this.outPageSize = val
      this.thckList()
    },
    outhandleCurrentChange(val) {
      this.outCurrentPage = val
      this.thckList()
    },
    // 内部分页方法
    pagesizeChange(val) {
      this.yszListPageSize = val
      this.yszListSearch()
    },
    handleCurrentChange(val) {
      this.yszListCurrentPage = val
      this.yszListSearch()
    },
    // 返回并清空
    back() {
      this.digshow = !this.digshow
      this.thckForm = {}
    },
    // 加载相关
    loadDataSource() {
      getListCkcx().then((e) => {
        this.ckKeyList = e.data.data
      })
      ckStatusList().then((e) => {
        this.statusList = e.data.data
      })
      userInfofLogin().then((e) => {
        this.djr = e.data.data.name
        if (!this.thckForm.djrLabel) {
          this.thckForm.djrLabel = this.djr
        }
      })
      this.thckList()
    }
  }
}
</script>

<style scoped lang='less'>
.sousuoButton {
  width: 90px;
  height: 39px;
  background: #4170ff;
  border-color: #4170ff;
}
.chongzhiButton {
  width: 90px;
  height: 39px;
}
.t_out_box {
  width: 95%;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1518px;
  /* background-color: white; */
}
.t_con_w {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
}
.t_search_form {
  display: flex;
  margin-bottom: 10px;
}
.t_search_form .el-form-item {
  margin-right: 30px;
  margin-bottom: 0;
}
.t_search_btn {
  width: 90px;
  height: 39px;
  background-color: #4170ff;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/* ------- */
.t_dig {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
  padding-top: 10px;
}

.bgcs_bg {
  padding: 0 20px 30px;
  margin-top: 15px;
  margin-bottom: 30px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  background-color: white;

  padding: 30px 10% 0;
}
.t_xkz,
.t_rk {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 40px;
  padding-bottom: 20px;
}
.el-pagination__total {
  margin-left: 8px;
}
.el-pagination {
  padding: 10px 0;

  border: 1px solid #ebeef5;
  border-top: 0;
}
.backButton {
  width: 148px;
  margin: 30px auto 40px auto;
  .el-button {
    margin: 30px auto;
    background-color: #4170ff;
    width: 148px;
    height: 60px;
    color: white;
    border: none;
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/.el-table__header-wrapper .el-checkbox {
  //找到表头那一行，然后把里面的复选框隐藏掉
  display: none;
}

.bgcs_SJTK {
  margin-top: 30px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
  padding-top: 30px;
  padding-bottom: 50px;
  background-color: white;

  .dialog-footer {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
</style>
